import { autoserialize } from 'cerialize';

export class FareAdjustment {
  @autoserialize
  reservationId: number;

  @autoserialize
  distanceMiles: number;

  @autoserialize
  durationSeconds: number;

  @autoserialize
  driverIncentive: number;

  @autoserialize
  driverTollReimbursement: number;
}
